import React, { ReactElement, useContext, useEffect } from 'react';

import Stepper from '@components/Stepper';
import { WizardContext } from './Wizard';
import { IWizardSectionProps } from './WizardStep';

interface IProps {
  children: ReactElement<IWizardSectionProps>[];
}

function WizardSteps({ children }: IProps) {
  const { stepIndex, setValidationSchemas } = useContext(WizardContext);

  useEffect(() => {
    setValidationSchemas(children.map((child) => child.props.validationSchema));
  }, [children]);

  return (
    <div className="modWizardSteps">
      <div className="modWizardSteps__stepper">
        <Stepper
          activeIndex={stepIndex}
          steps={children.map((child) => child.props.stepName ?? child.props.title)}
        />
      </div>
      <div className="modWizardSteps__active-section">{children[stepIndex]}</div>
    </div>
  );
}

export default WizardSteps;
